/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsWordpressArticlesWrapper_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedWordpressArticlesWrapper_viewer">;
    readonly " $refType": "SbRespInteriorsWordpressArticlesWrapper_viewer";
};
export type SbRespInteriorsWordpressArticlesWrapper_viewer$data = SbRespInteriorsWordpressArticlesWrapper_viewer;
export type SbRespInteriorsWordpressArticlesWrapper_viewer$key = {
    readonly " $data"?: SbRespInteriorsWordpressArticlesWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsWordpressArticlesWrapper_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsWordpressArticlesWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedWordpressArticlesWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'd3b28eea60ed9f75fec5509c8ab252a5';
export default node;
